export default "__VITE_ASSET__CxhNyg5U__"